import { LinearProgress as LinearProgressMui } from '@mui/material';
import { styled } from '@mui/material/styles';

export const LinearProgress = styled(LinearProgressMui)`
  width: 24px;
  margin-top: -5px;
  margin-left: 8px;
`;
